<template>
    <section class="faq-wrapper pt-80px pb-80px">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="section-header text-center">
                        <h1 class="section-title">Frequently Asked Questions</h1>
                        <p class="section-desc">
                            Find out everything you need to get started by taking the tour.
                        </p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-8 m-auto">
                    <div class="faq-content">
                        <faq-lists :items="dLabData.faqSectionData.faqLists" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import dLabData from '@/store/store';
import FaqLists from '../cards/FaqLists.vue'

export default {
    name: 'FaqSection',
    components: {
        FaqLists
    },
    data() {
        return {
            dLabData
        }
    }

}
</script>